import { Typography } from "@mui/material";
import { ReactElement } from "react";

export const LogoutPage = (): ReactElement => {
  return <Typography variant="h6">Logged out</Typography>;
};
